
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { PaymentService } from "../../../../../landing/src/utility/payment/PaymentService";
import { NotificationStore } from "../../../../../common/src/stores/NotificationStore";
import { Api } from "../../../../../common/src/api/Api";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { OrganizationSimilarOrganizationStore } from "../../../stores/organization/resource/OrganizationSimilarOrganizationStore";
import SubscriptionUpgrade from "./SubscriptionUpgrade.vue";
import SubscriptionUpgradeButton from "./SubscriptionUpgradeButton.vue";
import BedrockOrgResearch from "./BedrockOrgResearch.vue";

const lastUrlSegment = (url: string): string => url.match(/[^\/]+(?=\/$|$)/)?.[0] ?? "UNKNOWN";

@Component({
    components: {
        BedrockOrgResearch,
        LoadingOverlay,
        SubscriptionUpgrade,
        SubscriptionUpgradeButton,
    },
    filters: { lastUrlSegment },
})
export default class OrganizationOverview extends Vue {
    @Inject("container") readonly container!: Container;
    readonly organizationStore: OrganizationStore = this.container.get(OrganizationStore);
    readonly organizationSimilarOrganizationStore: OrganizationSimilarOrganizationStore =
        this.container.get(OrganizationSimilarOrganizationStore);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly api: Api = this.container.get(Api);
    readonly paymentService: PaymentService = this.container.get(PaymentService);
    readonly authStore: AuthStore = this.container.get(AuthStore);

    showMoreDescription = false;
    hasMoreContent = false;
    lastUrlSegment = (url: string): string => url.match(/[^\/]+(?=\/$|$)/)?.[0] ?? "UNKNOWN";

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        this.hasMoreContent = (this.organizationStore.item?.description?.length || 0) > 300;
        return this.organizationStore.item;
    }

    get hasNaicsList() {
        return (
            this.organization?.isBedrock &&
            this.organization?.naics &&
            this.organization?.naics?.length > 0
        );
    }

    get hasPscList() {
        return (
            this.organization?.isBedrock &&
            this.organization?.psc &&
            this.organization?.psc?.length > 0
        );
    }

    organizationUrl(organizationId: string) {
        return `/dashboard/organizations/${organizationId}`;
    }
}
